import SoftBadge from "modules/common/SoftBadge";
import React, { useContext, useState } from "react";
import OrderActions from "./OrderActions";
import {
  getCurrentUserRole,
  getFormattedDate,
  getShopifyLink,
  OFFLINE_STORE,
  showShopifyLinkAccess,
  statusDescriptions,
} from "modules/utilities/utility";
import Modal from "react-bootstrap/Modal";
import { Pagination, Popover } from "antd";
import SmallCopyIconData from "assets/svgs/small_copy_link";
import moment from "moment";
import ShopifyIcon from "assets/svgs/shopify";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { isEmpty } from "lodash";
import _ from "lodash";
import { get, some } from "lodash";
import { CustomerProps } from "./ShowCustomer";

function OrderCards({ orders }) {
  const [showCopiedModal, setShowCopiedModal] = useState(false);
  const [page, newPage] = useState(1);
  const [copied, setCopied] = useState();

  const { customer } = useContext(CustomerProps);

  const tagStyle = "text-wrap word-break m-1";

  const zeroConditionExists = (data) =>
    some(
      data,
      (item) => item?.name === "isZeroValueOrder" && item?.value === true
    );
  const zeroValuePrice = (data) => Number(data?.total_price) === 0;

  const handleCopy = (text, property) => {
    setCopied(property);
    navigator.clipboard
      .writeText(text)
      .then(() => {
        setShowCopiedModal(true);
        setTimeout(() => {
          setShowCopiedModal(false);
        }, 1000);
      })
      .catch((error) => {
        console.error("Failed to copy text to clipboard:", error);
      });
  };

  function extractPgTag(input) {
    const tag = get(input, "order_meta.tags", null);
    const match = tag ? tag.match(/(?:pg:|JUSPAY:)([^,]+)/) : null;
    return match ? match[1] : null;
  }

  const orderDetailData = (order) => {
    const fulfillments = order?.order_meta?.fulfillments || [];
    let fullFillment = "";

    if (fulfillments?.length === 0) {
      fullFillment = "unfulfilled";
    } else {
      const successFind = fulfillments?.find(
        (item) => item?.status === "success"
      );
      if (!successFind) {
        fullFillment = "fulfillment cancelled";
      } else {
        fullFillment = "fulfilled";
      }
    }

    return (
      <div className="d-flex  flex-column align-items-start">
        <div className="d-flex gap-3 ps-1 fs-1 align-items-center">
          <div className={order?.tracking_id ? null : "disabled-action"}>
            <SoftBadge>{order?.tracking_id || "N/A"}</SoftBadge>
          </div>
          <div className="p-1">
            <OverlayTrigger
              overlay={
                <Tooltip
                  style={{ position: "fixed" }}
                  id="overlay-trigger-example"
                >
                  Copy Tracking ID
                </Tooltip>
              }
            >
              <span
                className={
                  order?.tracking_id ? "cursor-pointer" : "disabled-action"
                }
                onClick={() => {
                  order?.tracking_id && handleCopy(order?.tracking_id, "ID");
                }}
              >
                <SmallCopyIconData />
              </span>
            </OverlayTrigger>
          </div>
        </div>
        {!isEmpty(order?.discount_code) ? (
          <div className="p-2">
            <SoftBadge>
              <span style={{ fontSize: 12 }}>
                Discount applied :{" "}
                {order?.discount_code ? (
                  <span>
                    {order?.discount_code} |
                    {order?.order_meta?.discount_applications?.[0]?.value} |
                    {order?.discount_type}
                  </span>
                ) : (
                  <span>none</span>
                )}
              </span>
            </SoftBadge>
          </div>
        ) : null}
        {order?.order_warehouse?.warehouses?.name && (
          <div>
            <SoftBadge className={tagStyle} bg="warning">
              <span style={{ fontSize: 12 }}>
                {order?.order_warehouse?.warehouses?.name}
              </span>
              <span className="ms-1">({fullFillment})</span>
            </SoftBadge>
          </div>
        )}
        {order?.is_prozo_invoiced === true && (
          <div>
            <SoftBadge className={tagStyle} bg="success">
              <span style={{ fontSize: 12 }}>PROZO INVOICED</span>
            </SoftBadge>
          </div>
        )}
        {order?.lagger && (
          <div>
            <SoftBadge className={tagStyle} bg="success">
              <span style={{ fontSize: 12 }}>Laggar</span>
            </SoftBadge>
          </div>
        )}
        {order?.uni_sales_order_date && (
          <div>
            <SoftBadge className={tagStyle} bg="success">
              <span style={{ fontSize: 12 }}>UNICOMMERCE</span>
            </SoftBadge>
          </div>
        )}
        {order?.order_type && (
          <span className="d-flex align-items-center justify-content-center">
            <Popover content="order type" placement="right">
              <>
                <SoftBadge bg="success" className={tagStyle}>
                  <span style={{ fontSize: 12 }}>
                    {order?.order_type.replaceAll("_", " ")}
                  </span>
                </SoftBadge>
              </>
            </Popover>
          </span>
        )}
        {extractPgTag(order) ? (
          <div className="p-1 shadow rounded">
            <SoftBadge className={tagStyle} bg="warning">
              {" "}
              Payment Id : {extractPgTag(order)}{" "}
            </SoftBadge>
          </div>
        ) : null}
        <div className="p-1 shadow rounded">
          <SoftBadge className={tagStyle} bg="warning">
            {" "}
            {order?.order_email}{" "}
          </SoftBadge>
        </div>
      </div>
    );
  };

  function activeOrder(index, customer) {
    const order = orders[index - 1];
    const orderNames = order?.order_meta.line_items?.map((order) => {
      return (
        <li>
          {order?.name} {`(${order.quantity})`}
        </li>
      );
    });

    const getPaymentGateways = (orderMeta) => {
      let paymentGateway = orderMeta?.gateway;
      if (!paymentGateway) {
        const paymentGatewayNames = _.get(
          orderMeta,
          ["payment_gateway_names"],
          []
        );
        if (
          paymentGatewayNames?.length > 0 &&
          !paymentGatewayNames?.[0]?.includes("COD")
        ) {
          paymentGateway = "manual";
        }
      }
      if (paymentGateway === "manual") {
        let tags = _.get(orderMeta, ["tags"], "");
        if (Array.isArray(tags)) {
          tags = tags[0];
        } else if (!tags || tags === "null" || _.isEmpty(tags)) {
          let paymentGatewayNames = _.get(
            orderMeta,
            ["payment_gateway_names"],
            []
          );
          if (paymentGatewayNames?.length > 0) {
            paymentGatewayNames = paymentGatewayNames?.[0] || "";
            if (paymentGatewayNames.toLowerCase().includes("payu")) {
              paymentGateway = "PayU";
            } else if (paymentGatewayNames.toLowerCase().includes("snapmint")) {
              paymentGateway = "Snapmint";
            } else if (paymentGatewayNames.toLowerCase().includes("razorpay")) {
              paymentGateway = "Razorpay";
            } else if (paymentGatewayNames.toLowerCase().includes("bharatx")) {
              paymentGateway = "BharatX";
            } else if (paymentGatewayNames.toLowerCase().includes("juspay")) {
              paymentGateway = "JUSPAY";
            } else if (paymentGatewayNames.toLowerCase().includes("simpl")) {
              paymentGateway = "Simpl";
            } else {
              paymentGateway = "COD";
            }
          } else {
            paymentGateway = "COD";
          }
        } else {
          let value = "";
          if (tags.toLowerCase().includes("payu")) {
            value = "PayU";
          } else if (tags.toLowerCase().includes("snapmint")) {
            value = "Snapmint";
          } else if (tags.toLowerCase().includes("razorpay")) {
            value = "Razorpay";
          } else if (tags.toLowerCase().includes("bharatx")) {
            value = "BharatX";
          } else if (tags.toLowerCase().includes("juspay")) {
            value = "JUSPAY";
          } else if (tags.toLowerCase().includes("simpl")) {
            value = "Simpl";
          } else {
            value = "COD";
          }
          paymentGateway = value;
        }
      } else {
        paymentGateway = "COD";
      }
      return paymentGateway;
    };

    const getOfflineOrder = (order) => {
      const noteAttributes = order?.order_meta?.note_attributes || [];
      const storeAttribute = noteAttributes.find(
        (el) => el?.name === "clinic_name"
      );
      return storeAttribute?.value || null;
    };

    return (
      <div
        style={{ minHeight: "10rem" }}
        key={order?.id}
        className=" d-flex py-0 justify-content-between rounded overflow-hidden border border-primary shadow mt-n2"
      >
        <div
          style={{ background: "#eee" }}
          className="d-flex flex-1 gap-2 flex-column p-2 border-end"
        >
          <div className="p-1">
            <Popover
              placement="right"
              content={
                <div>
                  <ol>{orderNames}</ol>
                  <div>
                    Shipping Address : <br />
                    {order?.order_meta?.shipping_address?.address1},
                    {order?.order_meta?.shipping_address?.address2},<br />
                    {order?.order_meta?.shipping_address?.city},
                    {order?.order_meta?.shipping_address?.province},
                    {order?.order_meta?.shipping_address?.zip}
                  </div>
                </div>
              }
            >
              <span className="cursor-pointer">
                <SoftBadge bg="info" className="fs-1">
                  {order?.order_display_id}
                </SoftBadge>
              </span>
            </Popover>
          </div>
          <div className="px-1">
            <SoftBadge className="fs-1">
              {getFormattedDate(order?.created_at)}
            </SoftBadge>
          </div>
          {showShopifyLinkAccess.includes(getCurrentUserRole()) && (
            <div>
              <a href={getShopifyLink(order.order_number)} target="_blank">
                <ShopifyIcon />
              </a>
            </div>
          )}
        </div>
        <div className="d-flex flex-3 flex-column p-2">
          <div className="d-flex">
            <div className="ps-2">
              <div className="d-flex gap-2 align-items-center px-1">
                <div className="d-flex fs-1 gap-3">
                  <a
                    href={customer?.orders[index - 1]?.tracking_url}
                    className="text-primary"
                    target="blank"
                  >
                    <SoftBadge
                      className={
                        customer?.orders[index - 1]?.tracking_url
                          ? ""
                          : "disabled-action"
                      }
                    >
                      Tracking url
                    </SoftBadge>
                  </a>
                </div>
                <div className="p-1">
                  <OverlayTrigger
                    overlay={
                      <Tooltip
                        style={{ position: "fixed" }}
                        id="overlay-trigger-example"
                      >
                        Copy Tracking URL
                      </Tooltip>
                    }
                  >
                    <span
                      className={
                        customer?.orders[index - 1]?.tracking_url
                          ? "cursor-pointer "
                          : "disabled-action"
                      }
                      onClick={() =>
                        customer?.orders[index - 1]?.tracking_url &&
                        handleCopy(
                          customer?.orders[index - 1]?.tracking_url,
                          "Link"
                        )
                      }
                    >
                      <SmallCopyIconData />
                    </span>
                  </OverlayTrigger>
                </div>
              </div>
            </div>{" "}
            <Popover
              placement="topLeft"
              title={"Order Tags"}
              content={orderDetailData(order)}
            >
              <div className="fw-bold ms-2 fs-1 cursor-pointer border px-2 rounded-circle">
                ...
              </div>
            </Popover>
          </div>

          <div className="p-2 d-flex flex-wrap">
            {order?.is_subscription && (
              <div>
                <SoftBadge bg="success" className={tagStyle}>
                  <span style={{ fontSize: 12 }}>
                    Subscription Order {subscriptionPlatform}
                  </span>
                </SoftBadge>
              </div>
            )}
            {(zeroConditionExists(
              get(order, "order_meta.note_attributes", [])
            ) ||
              zeroValuePrice(get(order, "order_meta", []))) && (
              <div>
                <SoftBadge bg="danger" className={tagStyle}>
                  <span style={{ fontSize: 12 }}>Zero Value Order</span>
                </SoftBadge>
              </div>
            )}
            {order?.is_bulk_order && (
              <div>
                <SoftBadge bg="success" className={tagStyle}>
                  <span style={{ fontSize: 12 }}>
                    Bulk Order ({order?.bulk_order_duration} months)
                  </span>
                </SoftBadge>
              </div>
            )}
            {order?.is_single_order && (
              <div>
                <SoftBadge bg="success" className={tagStyle}>
                  <span style={{ fontSize: 12 }}>Single Order</span>
                </SoftBadge>
              </div>
            )}
            {order?.is_combo && (
              <div>
                <SoftBadge bg="success" className={tagStyle}>
                  <span style={{ fontSize: 12 }}>Combo Order</span>
                </SoftBadge>
              </div>
            )}
            <SoftBadge key={order?.status} bg="primary" className={tagStyle}>
              <span style={{ fontSize: 12 }}>
                Status : {order?.status && order?.status.toUpperCase()} {""}
                {order?.sub_status ? (
                  <span className="ms-2 text-warning">
                    {order?.sub_status
                      ? ` | SubStatus : ${order?.sub_status}`
                      : ""}
                  </span>
                ) : null}
                <span className="ms-1">
                  {order.status === "delivered" ? "| " : null}
                  {order?.status === "delivered" &&
                    order?.delivery_date &&
                    moment.utc(order?.delivery_date).format("DD-MMM-YYYY")}
                </span>
              </span>
            </SoftBadge>
            {order?.is_international && (
              <div>
                <SoftBadge bg="info" className={tagStyle}>
                  <span style={{ fontSize: 12 }}>International</span>
                </SoftBadge>
              </div>
            )}
            <div>
              <SoftBadge bg="info" className={tagStyle}>
                <span style={{ fontSize: 12 }}>
                  {getPaymentGateways(order?.order_meta)} | {order?.source}{" "}
                  {get(order, "order_meta.request_source", null) ? "| OMS" : ""}
                  {order?.order_meta?.tags?.includes("JUSPAY")
                    ? "| JUSPAY"
                    : ""}
                </span>
              </SoftBadge>
            </div>
            {getOfflineOrder(order) && (
              <div>
                <SoftBadge bg="info" className={tagStyle}>
                  <span style={{ fontSize: 12 }}>{getOfflineOrder(order)}</span>
                </SoftBadge>
              </div>
            )}
            {order?.shopify_refund_return_status_code &&
              order?.order_type === "pre_paid" && (
                <div>
                  <SoftBadge bg="info" className={tagStyle}>
                    <span style={{ fontSize: 12 }}>
                      {
                        statusDescriptions[
                          order.shopify_refund_return_status_code
                        ]
                      }
                    </span>
                  </SoftBadge>
                </div>
              )}
            {order?.is_conditioner_free === true && (
              <div>
                <SoftBadge className={tagStyle} bg="success">
                  <span style={{ fontSize: 12 }}>CONDITIONER_FREE</span>
                </SoftBadge>
              </div>
            )}
          </div>
          <div>
            <div className="p-2 ps-3">
              <OrderActions
                prescriptions={orders}
                order={order}
                customerId={order?.case_id}
                userId={customer?.user_id}
                customer={customer}
              />
            </div>
          </div>
        </div>
        <Modal show={showCopiedModal} onHide={() => setShowCopiedModal(false)}>
          <Modal.Body>
            <span style={{ width: "5rem" }}>Tracking {copied} Copied!</span>
          </Modal.Body>
        </Modal>
      </div>
    );
  }
  const handlePaginationChange = (e) => {
    newPage(e);
  };
  return (
    <div>
      {orders?.length ? (
        <div className="d-flex align-items-center gap-1 flex-column ">
          <div className="w-100 shadow">{activeOrder(page, customer)}</div>
          <div className=" d-flex justify-content-end pe-5">
            <Pagination
              pageSize={1}
              current={page}
              total={orders.length}
              onChange={handlePaginationChange}
              showLessItems={true}
              style={{ textAlign: "center", marginTop: "5px" }}
              size="small"
            />
          </div>
        </div>
      ) : (
        <div className="d-flex" style={{ height: 165 }}>
          <SoftBadge
            bg="secondary"
            className="flex-fill fs-1 d-flex justify-content-center align-items-center h-100"
          >
            No order details available
          </SoftBadge>
        </div>
      )}
    </div>
  );
}

export default OrderCards;
